import React from 'react'
import './portfolio.css'
import one from '../../assets/1.jpg'
import five from '../../assets/2.jpg'
import four from '../../assets/3.jpg'
import six from '../../assets/9.jpg'
import nine from '../../assets/5.jpg'
import two from '../../assets/6.jpg'
import three from '../../assets/7.jpg'
import seven from '../../assets/8.jpg'
import eight from '../../assets/4.jpg'


const Portfolio = () => {
    return (
        <section id="portfolio">
            <h5>My Recent Work</h5>
            <h2>Portfolio</h2>
            <div className="container portfolio__container">
                <article className="portfolio__item">
                        <div className="portfolio__item-image">
                            <img src={one} alt="portfolio"/>
                        </div>
                    {/* <h3>Restaurant Responsive Design</h3>
                    <div className="portfolio__item-cta">
                        <a rel="noreferrer" href="https://github.com/kubrakkirill/restaurant" className="btn" target="_blank">Github</a>
                        <a rel="noreferrer" href="https://responsive-restaurant.onrender.com" className="btn btn-primary" target="_blank">Live Demo</a>
                    </div> */}
                </article>
                <article className="portfolio__item">
                        <div className="portfolio__item-image">
                            <img src={two} alt="portfolio"/>
                        </div>
                        {/* <h3>ChatGPT3 Responsive Design</h3>
                        <div className="portfolio__item-cta">
                            <a rel="noreferrer" href="https://github.com/kubrakkirill/ai-webpage" className="btn" target="_blank">Github</a>
                            <a rel="noreferrer" href="https://ai-webpage.onrender.com" className="btn btn-primary" target="_blank">Live Demo</a>
                        </div> */}
                </article>
                <article className="portfolio__item">
                        <div className="portfolio__item-image">
                            <img src={three} alt="portfolio"/>
                        </div>
                   {/* <h3>Search for Github users</h3>
                        <div className="portfolio__item-cta">
                            <a rel="noreferrer" href="https://github.com/kubrakkirill/App-GitHub" className="btn" target="_blank">Github</a>
                            <a rel="noreferrer" href="https://github-api-app.onrender.com" className="btn btn-primary" target="_blank">Live Demo</a>
                        </div> */}
                </article>
                <article className="portfolio__item">
                        <div className="portfolio__item-image">
                            <img src={four} alt="portfolio"/>
                        </div>
                    {/* <h3>Matrix Master Community (MERN stack)</h3>
                        <div className="portfolio__item-cta">
                            <a rel="noreferrer" href="https://github.com/kubrakkirill/mm-community" className="btn" target="_blank">Github</a>
                            <a rel="noreferrer" href="https://mm-community-site.onrender.com" className="btn btn-primary" target="_blank">Live Demo</a>
                        </div> */}
                </article>
                <article className="portfolio__item">
                        <div className="portfolio__item-image">
                            <img src={five} alt="portfolio"/>
                        </div>
                    {/* <h3>Matrix Master Community (MERN stack)</h3>
                        <div className="portfolio__item-cta">
                            <a rel="noreferrer" href="https://github.com/kubrakkirill/mm-community" className="btn" target="_blank">Github</a>
                            <a rel="noreferrer" href="https://mm-community-site.onrender.com" className="btn btn-primary" target="_blank">Live Demo</a>
                        </div> */}
                </article>
                <article className="portfolio__item">
                        <div className="portfolio__item-image">
                            <img src={six} alt="portfolio"/>
                        </div>
                    {/* <h3>Matrix Master Community (MERN stack)</h3>
                        <div className="portfolio__item-cta">
                            <a rel="noreferrer" href="https://github.com/kubrakkirill/mm-community" className="btn" target="_blank">Github</a>
                            <a rel="noreferrer" href="https://mm-community-site.onrender.com" className="btn btn-primary" target="_blank">Live Demo</a>
                        </div> */}
                </article>
                <article className="portfolio__item">
                        <div className="portfolio__item-image">
                            <img src={seven} alt="portfolio"/>
                        </div>
                    {/* <h3>Matrix Master Community (MERN stack)</h3>
                        <div className="portfolio__item-cta">
                            <a rel="noreferrer" href="https://github.com/kubrakkirill/mm-community" className="btn" target="_blank">Github</a>
                            <a rel="noreferrer" href="https://mm-community-site.onrender.com" className="btn btn-primary" target="_blank">Live Demo</a>
                        </div> */}
                </article>
                <article className="portfolio__item">
                        <div className="portfolio__item-image">
                            <img src={eight} alt="portfolio"/>
                        </div>
                    {/* <h3>Matrix Master Community (MERN stack)</h3>
                        <div className="portfolio__item-cta">
                            <a rel="noreferrer" href="https://github.com/kubrakkirill/mm-community" className="btn" target="_blank">Github</a>
                            <a rel="noreferrer" href="https://mm-community-site.onrender.com" className="btn btn-primary" target="_blank">Live Demo</a>
                        </div> */}
                </article>
                <article className="portfolio__item">
                        <div className="portfolio__item-image">
                            <img src={nine} alt="portfolio"/>
                        </div>
                    {/* <h3>Matrix Master Community (MERN stack)</h3>
                        <div className="portfolio__item-cta">
                            <a rel="noreferrer" href="https://github.com/kubrakkirill/mm-community" className="btn" target="_blank">Github</a>
                            <a rel="noreferrer" href="https://mm-community-site.onrender.com" className="btn btn-primary" target="_blank">Live Demo</a>
                        </div> */}
                </article>
            </div>
        </section>
    )
}
export default Portfolio
